//import moment from 'moment';

export const getFilterButtonsConfig = (onListAll, onFilter, userRole) =>  [ //onSetYear, year, 
  // {
  //   icon: 'date_range',
  //   name: year,
  //   isDropdown: true,
  //   isDisabled:  userRole === 'empleado' ? true : false,
  //   dropdownItems: 
  //   [
  //     {
  //       dropDownItemFuc: onSetYear,
  //       dropDownItemValue: moment().year() - 4,
  //       dropdownItemName: moment().year() - 4
  //     },
  //     {
  //       dropDownItemFuc: onSetYear,
  //       dropDownItemValue: moment().year() - 3,
  //       dropdownItemName: moment().year() - 3
  //     },
  //     {
  //       dropDownItemFuc: onSetYear,
  //       dropDownItemValue: moment().year() - 2,
  //       dropdownItemName: moment().year() - 2
  //     },
  //     {
  //       dropDownItemFuc: onSetYear,
  //       dropDownItemValue: moment().year() - 1,
  //       dropdownItemName: moment().year() - 1
  //     },
  //     {
  //       dropDownItemFuc: onSetYear,
  //       dropDownItemValue: moment().year(),
  //       dropdownItemName: moment().year()
  //     }
  //   ]
  // },
  // {
  //   func: redirectToVacationBalance,
  //   icon: 'date_range',
  //   name: 'Saldo de vacaciones',
  //   isDisabled:  userRole === 'empleado' ? true : false,
  //   isDropdown: false,
  //   dropdownItems: []
  // },
  {
    func: onListAll,
    icon: 'list',
    name: 'Listar todos',
    isDisabled:  userRole === 'empleado' ? true : false,
    isDropdown: false,
    dropdownItems: []
  },
  {
    func: onFilter,
    icon: 'filter_list',
    name: 'Filtros',
    isDropdown: false,
    dropdownItems: [],
    isDisabled: userRole !== 'administrador' ? true : false
  }
];